export class FetchAndSetMacOptions {
  constructor(
    setOnboardingOptions,
    setLoadingStates,
    setErrorStates,
    apiEndpoint
  ) {
    this.setOnboardingOptions = setOnboardingOptions;
    this.setLoadingStates = setLoadingStates;
    this.setErrorStates = setErrorStates;
    this.apiEndpoint = apiEndpoint;
    this.fetchAndSetOptions = this.fetchAndSetOptions.bind(this);
  }

  async fetchAndSetOptions(fetchData, key, id, setAppOptionsAvailable, appOptionsAvailable) {
    try {
      this.fetchingInitiated(key);
      let data = await fetchData(this.apiEndpoint, id);
      if(key === "app" && typeof setAppOptionsAvailable === "function") {
        if(data && data.length > 0 ){
          setAppOptionsAvailable(true)
        }else{
          setAppOptionsAvailable(false)
        }
      }else{
       if(appOptionsAvailable){
          setAppOptionsAvailable(false)
        
       }
      }
      this.setOnboardingOptions((currentOnboardingOptions) => {
        return {
          ...currentOnboardingOptions,
          [key]: data,
        };
      });
    } catch (error) {
      this.errorWhileFetching(key, `Error in fetching ${key} data`);
      console.error(error);
    } finally {
      this.completedFetching(key);
    }
  }

  fetchingInitiated(key) {
    this.setLoadingStates((prevState) => ({ ...prevState, [key]: true }));
  }

  completedFetching(key) {
    this.setLoadingStates((prevState) => ({ ...prevState, [key]: false }));
  }

  errorWhileFetching(errorFor, message) {
    this.setErrorStates((currentErrorStates) => {
      return {
        ...currentErrorStates,
        [errorFor]: {
          isError: true,
          errorMessage: message,
        },
      };
    });
  }
}
